import { getGames } from '@/services/game-service';
import { Query } from '@/types/QueryType';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import ms from 'ms';

const useGames = (query: Query) => {
    return useInfiniteQuery({
        queryKey: ["games", query],
        queryFn: ({ pageParam = 1 }) => getGames({
            params: {
                genres: query?.genreId,
                parent_platforms: query?.platformId,
                ordering: query?.sortOrder,
                search: query?.search,
                page: pageParam
            }
        }),
        getNextPageParam: (lastPage, allPages) => lastPage.next ? allPages.length + 1 : undefined,
        initialPageParam: 1,
        placeholderData: keepPreviousData,
        staleTime: ms('24h') // 10 minutes
    });
}

export default useGames;
